function initItemsSwiper() {
	const items = document.querySelectorAll('.items');

	items.forEach(section => {
		const sectionSwiper = section.querySelector('.items-swiper').className.split(' ')[1];

		const swiper = new Swiper(`.${sectionSwiper}`, {
			slidesPerView: 'auto',
			spaceBetween: 24,
			centeredSlides: true,
			grabCursor: true,
			scrollbar: {
				draggable: true,
				el: '.swiper-scrollbar',
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: {
				768: {
					centeredSlides: false,
				}
			}
		});
	});
}

window.addEventListener('DOMContentLoaded', () => {
	initItemsSwiper();
});